module.exports = __webpack_public_path__ + "img/spain-leukaemia-female.570258e5.png";